<template>
  <v-container fluid class="googlesheet-container pa-0 ma-0">
    <!-- Modern Header Section -->
    <div v-if="showHeader" class="header-section mb-6">
      <v-btn icon small class="header-close-btn" @click="dismissHeader">
        <v-icon color="white">mdi-close</v-icon>
      </v-btn>
      <div class="d-flex align-center mb-4">
        <div class="header-icon-wrapper mr-4">
          <v-icon size="32" color="#FFFFFF">mdi-google-spreadsheet</v-icon>
        </div>
        <div>
          <h1 class="page-title mb-1">Google Sheet Import</h1>
          <p class="page-subtitle mb-0">
            Import contacts from Google Sheets directly into your GoDial lists
          </p>
        </div>
        <v-spacer></v-spacer>
        <div class="d-none d-sm-flex">
          <v-chip
            small
            class="mr-2"
            color="rgba(255,255,255,0.2)"
            text-color="white"
          >
            <v-icon small left>mdi-google</v-icon>
            Google Workspace
          </v-chip>
        </div>
      </div>
      <v-row class="feature-pills ma-0">
        <v-col cols="6" sm="3" class="pa-1">
          <div class="feature-pill">
            <v-icon small class="mr-2" color="white">mdi-file-import</v-icon>
            <span>Quick Import</span>
          </div>
        </v-col>
        <v-col cols="6" sm="3" class="pa-1">
          <div class="feature-pill">
            <v-icon small class="mr-2" color="white">mdi-table</v-icon>
            <span>Field Mapping</span>
          </div>
        </v-col>
        <v-col cols="6" sm="3" class="pa-1">
          <div class="feature-pill">
            <v-icon small class="mr-2" color="white">mdi-google</v-icon>
            <span>Google Auth</span>
          </div>
        </v-col>
        <v-col cols="6" sm="3" class="pa-1">
          <div class="feature-pill">
            <v-icon small class="mr-2" color="white">mdi-contacts</v-icon>
            <span>Contact Sync</span>
          </div>
        </v-col>
      </v-row>
    </div>

    <!-- Content Section -->
    <div style="padding: 0 12px;">
      <v-card class="customBorderRadius elevation-2 py-5 px-4">
        <v-card-title>
          <v-row style="margin:0px !important">
            <v-flex xs12 sm6 offset-sm3 md6 offset-md3>
              <h2
                style="font-size: 24px; font-weight: 500; letter-spacing: 0.5px; opacity: 0.9"
              >
                Google Sheet Import
              </h2>
            </v-flex>
          </v-row>
        </v-card-title>
        <v-card-text>
          <v-row style="margin:0px !important">
            <v-flex xs12 sm6 offset-sm3 md6 offset-md3>
              <div>
                <h3
                  style="font-size: 16px; font-weight: 500; opacity: 0.9; margin-bottom: 20px; margin-top: -10px"
                >
                  GoDial allows you to import a Google sheet into a list easily.
                  Here is how it works
                </h3>
              </div>
            </v-flex>
            <v-flex xs12 sm6 offset-sm3 md6 offset-md3>
              <div>
                <p>1. Click Start</p>
                <p>2. Choose A Google sheet</p>
                <p>3. Choose List to import into</p>
                <p>4. Map the columns from your sheets with GoDial fields</p>
              </div>
            </v-flex>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-row style="margin: 0px">
            <v-flex
              xs12
              sm4
              offset-sm4
              md4
              offset-md4
              style="text-align: center !important"
            >
              <v-btn
                block
                color="primarygrad white--text"
                @click="openContactPicker"
              >
                Start
              </v-btn>
            </v-flex>
          </v-row>
        </v-card-actions>
      </v-card>
      <contactImport
        ref="contactImport"
        :lists="lists"
        :fieldlist="fieldList"
        :selectedlist="''"
      ></contactImport>

      <!-- Loader -->
      <v-dialog v-model="loader" persistent width="300">
        <v-card color="primary white--text" dark class="customBorderRadius">
          <v-card-text style="padding: 18px 25px">
            <h3 style="margin-bottom: 5px; font-weight: 400; font-size: 16px">
              Please Wait...
            </h3>
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
  </v-container>
</template>

<script>
import contactImport from "../components/contactImport.vue";

import { mapGetters } from "vuex";
const _ = require("lodash");

export default {
  components: {
    contactImport,
  },
  data() {
    return {
      showHeader: false,
      lists: [],
      loader: false,
    };
  },
  computed: {
    ...mapGetters(["ENDPOINT", "teams", "selectedTeam", "fieldList"]),
  },
  watch: {
    async selectedTeam() {
      try {
        await this.fetchLists(); // fetch list
      } catch (e) {
        console.log(e);
      }
    },
  },
  async mounted() {
    this.showHeader =
      localStorage.getItem("googleSheetHeaderDismissed") !== "true";
    await this.fetchLists();
  },

  methods: {
    dismissHeader() {
      this.showHeader = false;
      localStorage.setItem("googleSheetHeaderDismissed", "true");
    },
    // Open contact Picker
    openContactPicker() {
      this.$refs.contactImport.open("gSheet");
    },

    /** recieve teams array of ids */
    getTeamIds() {
      var teams = [];
      if (this.selectedTeam == "allTeams") {
        teams = _.map(this.teams, "id");
      } else {
        teams.push(this.selectedTeam);
      }
      teams = _.without(teams, "allTeams");
      return teams;
    },

    // Fetch all the lists
    async fetchLists() {
      try {
        this.loader = true;
        this.lists = [];
        // Teams sections
        var teamIds = this.getTeamIds();

        var res = await this.$http.post(`${this.ENDPOINT}/lists/fetch`, {
          teams: teamIds,
        });
        this.lists = res.body;
        this.loader = false;
      } catch (e) {
        console.log(e);
        this.loader = false;
      }
    },
  },
};
</script>
<style scoped>
.googlesheet-container {
  background-color: var(--v-background-base, #f5f5f5);
  min-height: 100vh;
}

.theme--dark .googlesheet-container {
  background-color: #121212 !important;
}

.header-section {
  background: linear-gradient(135deg, #37cf37 0%, #2ba82b 100%);
  border-radius: 12px;
  padding: 24px;
  color: white;
  box-shadow: 0 4px 20px rgba(55, 207, 55, 0.3);
}

.header-icon-wrapper {
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
  border-radius: 16px;
  width: 64px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.page-title {
  font-size: 28px;
  font-weight: 600;
  color: white;
  margin: 0;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.page-subtitle {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.95);
  margin: 0;
}

.feature-pills {
  margin-top: 16px;
}

.feature-pill {
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
  border-radius: 8px;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 13px;
  font-weight: 500;
  height: 100%;
  transition: all 0.3s ease;
}

.feature-pill:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: translateY(-2px);
}

p {
  margin: 4px;
}
</style>
